export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  description: string;
  fullDescription: string;
  category: string;
  status: string;
  chapters: ComicChapter[];
  rating: number;
  views: number;
  favorites: number;
  updatedAt: string;
  tags: string[];
}

export const categories = [
  { slug: 'all', name: '全部' },
  { slug: 'rexue', name: '热血' },
  { slug: 'gaoxiao', name: '搞笑' },
  { slug: 'lianai', name: '恋爱' },
  { slug: 'qihuan', name: '奇幻' },
  { slug: 'xuanyi', name: '悬疑' },
  { slug: 'richang', name: '日常' },
  { slug: 'zhiyu', name: '治愈' },
];

export const comics: Comic[] = [
  {
    id: 'dongdong-zahuopu',
    title: '洞洞杂货铺',
    author: '夏天岛工作室',
    coverImage: 'https://readdy.ai/api/search-image?query=Cute%20Japanese%20manga%20cover%20illustration%20of%20a%20cozy%20little%20grocery%20store%20with%20a%20friendly%20cat%20shopkeeper%20character%20wearing%20an%20apron%20surrounded%20by%20whimsical%20items%20on%20wooden%20shelves%20warm%20yellow%20lighting%20storybook%20art%20style%20soft%20watercolor%20texture%20gentle%20pastel%20colors%20charming%20and%20heartwarming%20atmosphere%20clean%20composition%20with%20title%20space&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    description: '在一家不起眼的杂货铺里，每一件商品都藏着一段奇妙的故事。店主阿洞是个神秘的年轻人，他能听见物品的"心声"。当顾客走进杂货铺，阿洞总能递给他们最需要的那件物品...',
    fullDescription: '在一家不起眼的杂货铺里，每一件商品都藏着一段奇妙的故事。店主阿洞是个神秘的年轻人，他能听见物品的"心声"。当顾客走进杂货铺，阿洞总能递给他们最需要的那件物品——也许是一把能打开回忆的钥匙，也许是一本能预知天气的笔记本，又或者是一盒吃了会做美梦的糖果。温暖治愈的日常，夹杂着奇幻与悬疑，洞洞杂货铺的故事正在展开...',
    category: 'zhiyu',
    status: '连载中',
    chapters: [
      { id: 'ch-001', title: '第1话 会说话的旧怀表', number: 1, updatedAt: '2026-08-01' },
      { id: 'ch-002', title: '第2话 雨天的客人', number: 2, updatedAt: '2026-07-28' },
      { id: 'ch-003', title: '第3话 回忆的钥匙', number: 3, updatedAt: '2026-07-25' },
      { id: 'ch-004', title: '第4话 梦境的糖果', number: 4, updatedAt: '2026-07-22' },
      { id: 'ch-005', title: '第5话 风中的旋律', number: 5, updatedAt: '2026-07-19' },
      { id: 'ch-006', title: '第6话 星光笔记本', number: 6, updatedAt: '2026-07-16' },
      { id: 'ch-007', title: '第7话 旧照片的秘密', number: 7, updatedAt: '2026-07-13' },
      { id: 'ch-008', title: '第8话 温暖的围巾', number: 8, updatedAt: '2026-07-10' },
      { id: 'ch-009', title: '第9话 不可思议的指南针', number: 9, updatedAt: '2026-07-07' },
      { id: 'ch-010', title: '第10话 杂货铺的夜晚', number: 10, updatedAt: '2026-07-04' },
    ],
    rating: 9.6,
    views: 1285600,
    favorites: 356800,
    updatedAt: '2026-08-01',
    tags: ['治愈', '奇幻', '日常', '温情'],
  },
  {
    id: 'xingkong-qiyuan',
    title: '星空奇缘',
    author: '墨羽工作室',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20cover%20illustration%20of%20a%20boy%20and%20girl%20standing%20under%20a%20beautiful%20starry%20night%20sky%20with%20glowing%20constellations%20fantasy%20romance%20theme%20soft%20blue%20and%20purple%20twilight%20colors%20dreamy%20atmosphere%20clean%20manga%20art%20style%20subtle%20sparkle%20effects%20warm%20emotional%20tone&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    description: '高中生林星辰在某天夜里，意外发现自家阳台上出现了一位来自星星的神秘少女。她说自己是为了寻找失落的星座碎片而来，而林星辰恰好是唯一能看见她的人...',
    fullDescription: '高中生林星辰在某天夜里，意外发现自家阳台上出现了一位来自星星的神秘少女。她说自己是为了寻找失落的星座碎片而来，而林星辰恰好是唯一能看见她的人。于是，一段穿梭于星空与人间的奇妙冒险开始了。他们将在城市的角落里寻找散落的星座碎片，每找到一片，就会解锁一段被遗忘的星空传说。热血与浪漫交织的奇幻故事，等你来探索！',
    category: 'qihuan',
    status: '连载中',
    chapters: [
      { id: 'ch-101', title: '第1话 星空下的相遇', number: 1, updatedAt: '2026-07-30' },
      { id: 'ch-102', title: '第2话 星座碎片', number: 2, updatedAt: '2026-07-27' },
      { id: 'ch-103', title: '第3话 第一个任务', number: 3, updatedAt: '2026-07-24' },
      { id: 'ch-104', title: '第4话 天台的秘密', number: 4, updatedAt: '2026-07-21' },
      { id: 'ch-105', title: '第5话 过去的记忆', number: 5, updatedAt: '2026-07-18' },
    ],
    rating: 9.3,
    views: 892300,
    favorites: 245600,
    updatedAt: '2026-07-30',
    tags: ['奇幻', '恋爱', '冒险', '青春'],
  },
  {
    id: 'rexue-jianghu',
    title: '热血江湖录',
    author: '狂风漫画',
    coverImage: 'https://readdy.ai/api/search-image?query=Action%20manga%20cover%20illustration%20of%20a%20young%20swordsman%20in%20traditional%20Chinese%20martial%20arts%20attire%20dynamic%20fighting%20pose%20with%20flowing%20robes%20against%20a%20dramatic%20sunset%20mountain%20backdrop%20ink%20wash%20painting%20style%20bold%20brushstrokes%20warm%20orange%20and%20red%20tones%20epic%20atmosphere&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    description: '少年江辰自幼失去双亲，被江湖第一剑客收养。十年苦练，他终于执剑下山，踏上寻找仇人、匡扶正义的江湖之路。一路上遇到各路英雄豪杰，也遭遇重重险境...',
    fullDescription: '少年江辰自幼失去双亲，被江湖第一剑客收养。十年苦练，他终于执剑下山，踏上寻找仇人、匡扶正义的江湖之路。一路上遇到各路英雄豪杰，也遭遇重重险境。从江南水乡到西域大漠，从名门正派到邪道魔教，江辰在一次次的战斗中成长，逐渐揭开了当年灭门惨案的真相。热血沸腾的江湖传奇，等你来战！',
    category: 'rexue',
    status: '连载中',
    chapters: [
      { id: 'ch-201', title: '第1话 下山', number: 1, updatedAt: '2026-07-29' },
      { id: 'ch-202', title: '第2话 初战', number: 2, updatedAt: '2026-07-26' },
      { id: 'ch-203', title: '第3话 江南烟雨', number: 3, updatedAt: '2026-07-23' },
      { id: 'ch-204', title: '第4话 擂台比武', number: 4, updatedAt: '2026-07-20' },
      { id: 'ch-205', title: '第5话 神秘老者', number: 5, updatedAt: '2026-07-17' },
      { id: 'ch-206', title: '第6话 夜袭', number: 6, updatedAt: '2026-07-14' },
    ],
    rating: 9.4,
    views: 1567800,
    favorites: 423500,
    updatedAt: '2026-07-29',
    tags: ['热血', '武侠', '冒险', '战斗'],
  },
  {
    id: 'gaoxiao-richang',
    title: '小明今天也很崩溃',
    author: '不二马漫画',
    coverImage: 'https://readdy.ai/api/search-image?query=Funny%20comedy%20manga%20cover%20illustration%20of%20a%20student%20boy%20with%20exaggerated%20funny%20facial%20expression%20holding%20a%20zero%20score%20test%20paper%20surrounded%20by%20chaotic%20school%20items%20colorful%20and%20lively%20cartoon%20style%20bright%20cheerful%20colors%20humorous%20atmosphere%20clean%20line%20art%20with%20pop%20art%20elements&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    description: '普通中学生小明的日常生活，充满了各种令人捧腹的乌龙事件。从考试零分到被老师罚站，从食堂抢饭到操场摔跤，小明的每一天都是一场"生存挑战"...',
    fullDescription: '普通中学生小明的日常生活，充满了各种令人捧腹的乌龙事件。从考试零分到被老师罚站，从食堂抢饭到操场摔跤，小明的每一天都是一场"生存挑战"。但这并不是一个简单的搞笑漫画——在笑声背后，你还能看到友情、成长和那些闪闪发光的青春瞬间。笑中带泪，这才是真正的校园生活！',
    category: 'gaoxiao',
    status: '连载中',
    chapters: [
      { id: 'ch-301', title: '第1话 开学第一天', number: 1, updatedAt: '2026-07-31' },
      { id: 'ch-302', title: '第2话 考试风云', number: 2, updatedAt: '2026-07-28' },
      { id: 'ch-303', title: '第3话 食堂大作战', number: 3, updatedAt: '2026-07-25' },
      { id: 'ch-304', title: '第4话 运动会', number: 4, updatedAt: '2026-07-22' },
    ],
    rating: 9.2,
    views: 2100500,
    favorites: 567800,
    updatedAt: '2026-07-31',
    tags: ['搞笑', '校园', '日常', '青春'],
  },
  {
    id: 'huakai-shengji',
    title: '花开的声音',
    author: '花卷漫画社',
    coverImage: 'https://readdy.ai/api/search-image?query=Romance%20shojo%20manga%20cover%20illustration%20of%20a%20gentle%20girl%20with%20long%20flowing%20hair%20holding%20a%20bouquet%20of%20cherry%20blossoms%20soft%20spring%20sunlight%20filtering%20through%20blooming%20trees%20pastel%20pink%20and%20cream%20color%20palette%20delicate%20watercolor%20texture%20dreamy%20romantic%20atmosphere%20shojo%20manga%20art%20style&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    description: '花店女孩苏晓晴有着一个秘密——她培育的花能够听懂人的心事。当她暗恋的男生搬到隔壁后，她花园里的花开得格外绚烂。一段关于花与爱的青春物语就此展开...',
    fullDescription: '花店女孩苏晓晴有着一个秘密——她培育的花能够听懂人的心事。当她暗恋的男生搬到隔壁后，她花园里的花开得格外绚烂。每一朵花都在诉说着她的心意，每一片花瓣都承载着她的期待。但苏晓晴不知道的是，那个男生也有着不为人知的秘密...一段关于花与爱的青春物语就此展开，温暖治愈的恋爱故事。',
    category: 'lianai',
    status: '已完结',
    chapters: [
      { id: 'ch-401', title: '第1话 隔壁的男孩', number: 1, updatedAt: '2026-06-15' },
      { id: 'ch-402', title: '第2话 满天星的心意', number: 2, updatedAt: '2026-06-12' },
      { id: 'ch-403', title: '第3话 雨天的告白', number: 3, updatedAt: '2026-06-09' },
      { id: 'ch-404', title: '第4话 玫瑰与刺', number: 4, updatedAt: '2026-06-06' },
      { id: 'ch-405', title: '第5话 向日葵的方向', number: 5, updatedAt: '2026-06-03' },
      { id: 'ch-406', title: '第6话 花开的季节', number: 6, updatedAt: '2026-05-31' },
      { id: 'ch-407', title: '第7话 永恒之约（终）', number: 7, updatedAt: '2026-05-28' },
    ],
    rating: 9.7,
    views: 1892300,
    favorites: 612400,
    updatedAt: '2026-06-15',
    tags: ['恋爱', '治愈', '青春', '花语'],
  },
  {
    id: 'anying-zhentan',
    title: '暗影侦探',
    author: '极夜漫画',
    coverImage: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20manga%20cover%20illustration%20of%20a%20detective%20in%20a%20trench%20coat%20standing%20in%20a%20dark%20alley%20with%20streetlamp%20casting%20long%20shadows%20noir%20atmosphere%20with%20film%20grain%20texture%20dark%20and%20moody%20tones%20with%20a%20single%20warm%20light%20source%20suspenseful%20composition%20mature%20seinen%20art%20style&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    description: '退休刑警陈默在接手一起看似普通的失踪案后，被卷入了一场横跨十年的连环案件。每一个线索都指向一个神秘组织，而组织的首领似乎是陈默的旧识...',
    fullDescription: '退休刑警陈默在接手一起看似普通的失踪案后，被卷入了一场横跨十年的连环案件。每一个线索都指向一个神秘组织——"暗影"，而组织的首领似乎是陈默的旧识。为了揭开真相，陈默不得不重新踏上那条布满荆棘的侦探之路。悬疑重重、反转不断，你能比陈默更早看穿真相吗？',
    category: 'xuanyi',
    status: '连载中',
    chapters: [
      { id: 'ch-501', title: '第1话 失踪者', number: 1, updatedAt: '2026-07-28' },
      { id: 'ch-502', title: '第2话 十年前', number: 2, updatedAt: '2026-07-25' },
      { id: 'ch-503', title: '第3话 第一个嫌疑人', number: 3, updatedAt: '2026-07-22' },
      { id: 'ch-504', title: '第4话 暗号', number: 4, updatedAt: '2026-07-19' },
      { id: 'ch-505', title: '第5话 意外的证人', number: 5, updatedAt: '2026-07-16' },
      { id: 'ch-506', title: '第6话 组织的真面目', number: 6, updatedAt: '2026-07-13' },
    ],
    rating: 9.5,
    views: 987600,
    favorites: 289400,
    updatedAt: '2026-07-28',
    tags: ['悬疑', '推理', '犯罪', '剧情'],
  },
  {
    id: 'maomi-kafei',
    title: '猫咪咖啡馆',
    author: '暖阳漫画',
    coverImage: 'https://readdy.ai/api/search-image?query=Cute%20slice%20of%20life%20manga%20cover%20illustration%20of%20various%20fluffy%20cats%20relaxing%20in%20a%20cozy%20cafe%20setting%20with%20warm%20wooden%20furniture%20and%20coffee%20cups%20soft%20natural%20light%20from%20large%20windows%20gentle%20and%20calming%20atmosphere%20cream%20and%20caramel%20color%20palette%20healing%20iyashikei%20style&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    description: '在城市的一角，有一家由猫咪们经营的咖啡馆。每一只猫咪都有自己独特的性格和拿手咖啡。来这里喝一杯咖啡，和猫咪们聊聊天，疲惫的心灵就此被治愈...',
    fullDescription: '在城市的一角，有一家由猫咪们经营的咖啡馆。橘猫店长擅长做拿铁，暹罗猫是拉花大师，黑猫负责招待客人，白猫则安静地坐在窗边看书。每一只猫咪都有自己独特的故事，每一位来到咖啡馆的客人也都带着各自的心事。在这里，咖啡的香气和猫咪的陪伴能治愈一切。温暖日常的治愈系漫画，每一页都散发着咖啡和阳光的味道。',
    category: 'zhiyu',
    status: '连载中',
    chapters: [
      { id: 'ch-601', title: '第1话 橘猫店长', number: 1, updatedAt: '2026-07-27' },
      { id: 'ch-602', title: '第2话 第一位客人', number: 2, updatedAt: '2026-07-24' },
      { id: 'ch-603', title: '第3话 拉花的心意', number: 3, updatedAt: '2026-07-21' },
      { id: 'ch-604', title: '第4话 雨天的访客', number: 4, updatedAt: '2026-07-18' },
    ],
    rating: 9.5,
    views: 765400,
    favorites: 198700,
    updatedAt: '2026-07-27',
    tags: ['治愈', '日常', '猫咪', '温馨'],
  },
  {
    id: 'jiechu-tianji',
    title: '接触天际',
    author: '星辰动漫',
    coverImage: 'https://readdy.ai/api/search-image?query=Shonen%20manga%20cover%20illustration%20of%20a%20teenage%20boy%20reaching%20toward%20the%20sky%20with%20determination%20surrounded%20by%20floating%20islands%20and%20clouds%20adventure%20fantasy%20theme%20vibrant%20blue%20sky%20with%20white%20clouds%20dynamic%20composition%20clean%20shonen%20art%20style%20inspiring%20and%20epic%20tone&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    description: '在浮空岛组成的世界里，少年阿空梦想着到达传说中的"天际之顶"。为了这个梦想，他驾驶着自己组装的飞行器，踏上了穿越云海的冒险之旅...',
    fullDescription: '在浮空岛组成的世界里，少年阿空梦想着到达传说中的"天际之顶"——那是所有人都说不可能到达的地方。为了这个梦想，他驾驶着自己组装的飞行器，与伙伴们一起踏上了穿越云海的冒险之旅。一路上，他们将遭遇暴风、海怪、空中强盗，但也会遇到善良的岛民和神秘的古代遗迹。热血与勇气的飞行冒险，起飞！',
    category: 'rexue',
    status: '连载中',
    chapters: [
      { id: 'ch-701', title: '第1话 起飞之日', number: 1, updatedAt: '2026-07-26' },
      { id: 'ch-702', title: '第2话 云海之上', number: 2, updatedAt: '2026-07-23' },
      { id: 'ch-703', title: '第3话 暴风来袭', number: 3, updatedAt: '2026-07-20' },
      { id: 'ch-704', title: '第4话 天空之城', number: 4, updatedAt: '2026-07-17' },
    ],
    rating: 9.1,
    views: 654300,
    favorites: 176500,
    updatedAt: '2026-07-26',
    tags: ['热血', '冒险', '奇幻', '飞行'],
  },
];

export const featuredComicIds = ['dongdong-zahuopu', 'xingkong-qiyuan', 'huakai-shengji', 'rexue-jianghu'];

export const hotComicIds = ['dongdong-zahuopu', 'gaoxiao-richang', 'huakai-shengji', 'rexue-jianghu', 'anying-zhentan', 'maomi-kafei'];

export const latestComicIds = ['gaoxiao-richang', 'dongdong-zahuopu', 'xingkong-qiyuan', 'rexue-jianghu', 'anying-zhentan', 'jiechu-tianji', 'maomi-kafei', 'huakai-shengji'];